/* FlexOn Diwali theme – interactions, cart and festive effects */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');

  var T = window.FlexOn || {};
  var reduceMotion = !!(T.fx && T.fx.respectReduce) && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduceMotion) document.documentElement.classList.add('fx-reduce');
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function rand(a, b) { return a + Math.random() * (b - a); }
  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  /* ------------------------------------------------------------
     Money
  ------------------------------------------------------------ */
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = parseInt(cents, 10) || 0;
    var format = T.moneyFormat || '₹{{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      var num = (n / 100).toFixed(precision);
      var parts = num.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = withDelims(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelims(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(cents, 2, "'", '.'); break;
      default: value = withDelims(cents, 2);
    }
    value = value.replace(/\.00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }
  T.formatMoney = formatMoney;

  /* ------------------------------------------------------------
     Fireworks engine
  ------------------------------------------------------------ */
  var PALETTES = [
    ['#ffd36e', '#fff1c1', '#ffb13b'],
    ['#ff8f1f', '#ffd27a', '#fff'],
    ['#ff4f8b', '#ffc2d8', '#ffd36e'],
    ['#7cf0a9', '#d5ffe6', '#ffd36e'],
    ['#8fb8ff', '#e2ecff', '#ffd36e'],
    ['#c58bff', '#f0dcff', '#ffd36e'],
    ['#ff5a3c', '#ffcf6a', '#fff5d6']
  ];

  function Fireworks(canvas, opts) {
    this.c = canvas;
    this.ctx = canvas.getContext('2d');
    this.opts = opts || {};
    this.rockets = [];
    this.sparks = [];
    this.fountains = [];
    this.running = false;
    this.lastLaunch = 0;
    this.dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    this.maxSparks = isMobile ? 420 : 900;
    this.resize();
    var self = this;
    window.addEventListener('resize', function () { self.resize(); });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) self.start(); });
  }
  Fireworks.prototype.resize = function () {
    this.w = window.innerWidth; this.h = window.innerHeight;
    this.c.width = Math.floor(this.w * this.dpr);
    this.c.height = Math.floor(this.h * this.dpr);
    this.ctx.setTransform(this.dpr, 0, 0, this.dpr, 0, 0);
  };
  Fireworks.prototype.start = function () {
    if (this.running) return;
    this.running = true;
    var self = this, last = performance.now();
    function frame(now) {
      if (document.hidden) { self.running = false; return; }
      var dt = Math.min((now - last) / 16.67, 3); last = now;
      self.step(dt, now);
      if (self.rockets.length || self.sparks.length || self.fountains.length || self.opts.ambient) {
        requestAnimationFrame(frame);
      } else {
        self.ctx.clearRect(0, 0, self.w, self.h);
        self.running = false;
      }
    }
    requestAnimationFrame(frame);
  };
  Fireworks.prototype.launch = function (x, targetY, palette) {
    x = x == null ? rand(this.w * 0.08, this.w * 0.92) : x;
    targetY = targetY == null ? rand(this.h * 0.08, this.h * 0.42) : targetY;
    var dist = this.h - targetY;
    this.rockets.push({
      x: x, y: this.h + 10, vx: rand(-0.6, 0.6), vy: -Math.sqrt(2 * 0.12 * dist) * 1.02,
      ty: targetY, pal: palette || pick(PALETTES), trail: []
    });
    this.start();
  };
  Fireworks.prototype.burst = function (x, y, opts) {
    opts = opts || {};
    var pal = opts.palette || pick(PALETTES);
    var type = opts.type || pick(['peony', 'peony', 'ring', 'willow', 'palm', 'crackle']);
    var scale = opts.scale || 1;
    var n = Math.round((opts.count || (type === 'ring' ? 60 : type === 'palm' ? 14 : 90)) * (isMobile ? 0.65 : 1));
    if (this.sparks.length > this.maxSparks) n = Math.round(n * 0.3);
    for (var i = 0; i < n; i++) {
      var a = (Math.PI * 2 * i) / n + rand(-0.05, 0.05);
      var sp;
      if (type === 'ring') sp = 4.2 * scale;
      else if (type === 'palm') sp = rand(3.5, 5.5) * scale;
      else sp = rand(1, 5.2) * scale;
      var s = {
        x: x, y: y, vx: Math.cos(a) * sp, vy: Math.sin(a) * sp,
        life: 1, decay: rand(0.010, 0.02), color: pick(pal),
        size: rand(1.2, 2.4) * (type === 'palm' ? 1.6 : 1), g: 0.05, f: 0.975,
        flicker: type === 'crackle' || Math.random() < 0.25, px: x, py: y
      };
      if (type === 'willow') { s.decay = rand(0.006, 0.011); s.g = 0.035; s.f = 0.965; s.color = pick(['#ffd36e', '#ffbf4a', '#fff1c1']); }
      if (type === 'palm') { s.decay = rand(0.008, 0.013); s.trailSpawn = true; }
      if (type === 'crackle') { s.decay = rand(0.02, 0.035); s.crackle = true; }
      this.sparks.push(s);
    }
    // flash
    this.sparks.push({ x: x, y: y, vx: 0, vy: 0, life: 1, decay: 0.08, color: '#fff7e0', size: 26 * scale, g: 0, f: 1, flash: true, px: x, py: y });
    this.start();
  };
  Fireworks.prototype.fountain = function (x, y, ms) {
    this.fountains.push({ x: x, y: y, until: performance.now() + (ms || 900) });
    this.start();
  };
  Fireworks.prototype.sparkle = function (x, y, n, spread) {
    for (var i = 0; i < (n || 2); i++) {
      this.sparks.push({ x: x, y: y, vx: rand(-1, 1) * (spread || 1), vy: rand(-1.4, 0.4) * (spread || 1), life: 1, decay: rand(0.03, 0.06), color: pick(['#ffd36e', '#fff1c1', '#ffb13b', '#ff8fb3']), size: rand(0.8, 1.8), g: 0.03, f: 0.96, flicker: true, px: x, py: y });
    }
    this.start();
  };
  Fireworks.prototype.step = function (dt, now) {
    var ctx = this.ctx;
    // fade existing pixels to transparent (trails)
    ctx.globalCompositeOperation = 'destination-out';
    ctx.fillStyle = 'rgba(0,0,0,' + (0.22 * dt) + ')';
    ctx.fillRect(0, 0, this.w, this.h);
    ctx.globalCompositeOperation = 'lighter';

    // ambient launches
    if (this.opts.ambient && now - this.lastLaunch > this.opts.interval * rand(0.6, 1.4)) {
      this.lastLaunch = now;
      this.launch();
    }

    // fountains (anar)
    for (var f = this.fountains.length - 1; f >= 0; f--) {
      var ft = this.fountains[f];
      if (now > ft.until) { this.fountains.splice(f, 1); continue; }
      for (var k = 0; k < 6; k++) {
        var ang = -Math.PI / 2 + rand(-0.45, 0.45), v = rand(3, 7.5);
        this.sparks.push({ x: ft.x, y: ft.y, vx: Math.cos(ang) * v, vy: Math.sin(ang) * v, life: 1, decay: rand(0.018, 0.03), color: pick(['#ffd36e', '#fff1c1', '#ffb13b', '#ff8f1f']), size: rand(1, 2), g: 0.14, f: 0.985, flicker: true, px: ft.x, py: ft.y });
      }
    }

    // rockets
    for (var r = this.rockets.length - 1; r >= 0; r--) {
      var rk = this.rockets[r];
      rk.px = rk.x; rk.py = rk.y;
      rk.x += rk.vx * dt; rk.y += rk.vy * dt; rk.vy += 0.12 * dt;
      ctx.strokeStyle = 'rgba(255,214,140,0.9)';
      ctx.lineWidth = 2;
      ctx.beginPath(); ctx.moveTo(rk.px, rk.py + 6); ctx.lineTo(rk.x, rk.y); ctx.stroke();
      if (Math.random() < 0.6) this.sparks.push({ x: rk.x, y: rk.y + 4, vx: rand(-0.4, 0.4), vy: rand(0.5, 1.5), life: 0.8, decay: 0.05, color: '#ffc15a', size: 1, g: 0.02, f: 0.95, px: rk.x, py: rk.y });
      if (rk.vy >= -0.5 || rk.y <= rk.ty) {
        this.rockets.splice(r, 1);
        this.burst(rk.x, rk.y, { palette: rk.pal, scale: rand(0.85, 1.25) });
      }
    }

    // sparks
    for (var i = this.sparks.length - 1; i >= 0; i--) {
      var s = this.sparks[i];
      s.px = s.x; s.py = s.y;
      s.vx *= Math.pow(s.f, dt); s.vy = s.vy * Math.pow(s.f, dt) + s.g * dt;
      s.x += s.vx * dt; s.y += s.vy * dt;
      s.life -= s.decay * dt;
      if (s.life <= 0) {
        if (s.crackle && Math.random() < 0.5) {
          for (var c = 0; c < 4; c++) this.sparks.push({ x: s.x, y: s.y, vx: rand(-1.5, 1.5), vy: rand(-1.5, 1.5), life: 0.6, decay: 0.08, color: '#fff6d6', size: 1, g: 0.02, f: 0.9, px: s.x, py: s.y });
        }
        this.sparks.splice(i, 1); continue;
      }
      if (s.trailSpawn && Math.random() < 0.3) this.sparks.push({ x: s.x, y: s.y, vx: 0, vy: 0.3, life: 0.5, decay: 0.05, color: s.color, size: 0.9, g: 0.02, f: 0.9, px: s.x, py: s.y });
      var alpha = s.flicker ? s.life * (Math.random() < 0.3 ? 0.3 : 1) : s.life;
      if (s.flash) {
        var grd = ctx.createRadialGradient(s.x, s.y, 0, s.x, s.y, s.size);
        grd.addColorStop(0, 'rgba(255,245,215,' + (0.55 * s.life) + ')');
        grd.addColorStop(1, 'rgba(255,200,100,0)');
        ctx.fillStyle = grd;
        ctx.beginPath(); ctx.arc(s.x, s.y, s.size, 0, Math.PI * 2); ctx.fill();
        continue;
      }
      ctx.globalAlpha = Math.max(alpha, 0);
      ctx.strokeStyle = s.color;
      ctx.lineWidth = s.size;
      ctx.lineCap = 'round';
      ctx.beginPath(); ctx.moveTo(s.px, s.py); ctx.lineTo(s.x, s.y); ctx.stroke();
    }
    ctx.globalAlpha = 1;
  };

  var fxBg = null, fxTop = null;
  function initFx() {
    var s = T.fx || {};
    var bg = document.getElementById('fx-bg');
    var top = document.getElementById('fx-top');
    if (top) fxTop = new Fireworks(top, { ambient: false });
    if (bg && s.fireworks && !reduceMotion) {
      var interval = { low: 2800, medium: 1600, high: 750 }[s.intensity || 'medium'];
      if (isMobile) interval *= 1.4;
      fxBg = new Fireworks(bg, { ambient: true, interval: interval });
      // opening salute
      setTimeout(function () { fxBg.launch(fxBg.w * 0.25); }, 300);
      setTimeout(function () { fxBg.launch(fxBg.w * 0.75); }, 700);
      setTimeout(function () { fxBg.launch(fxBg.w * 0.5, fxBg.h * 0.18); }, 1100);
      fxBg.start();
    }
    if (!fxTop || reduceMotion) return;
    if (s.cursor && finePointer) {
      var lastT = 0;
      window.addEventListener('pointermove', function (e) {
        var n = performance.now();
        if (n - lastT < 28) return; lastT = n;
        fxTop.sparkle(e.clientX, e.clientY, 1, 0.8);
      }, { passive: true });
    }
    if (s.click) {
      document.addEventListener('pointerdown', function (e) {
        if (e.target.closest('input,textarea,select,[data-no-burst]')) return;
        fxTop.burst(e.clientX, e.clientY, { count: 18, scale: 0.45, type: 'peony' });
      }, { passive: true });
    }
  }

  function celebrate(el, big) {
    if (!fxTop || reduceMotion || !(T.fx && T.fx.atc)) return;
    var r = el && el.getBoundingClientRect ? el.getBoundingClientRect() : { left: window.innerWidth / 2, top: window.innerHeight / 2, width: 0, height: 0 };
    var x = r.left + r.width / 2, y = r.top + r.height / 2;
    fxTop.fountain(x, r.top + r.height * 0.2, 700);
    fxTop.burst(x, y - 30, { type: 'peony', scale: 1.1 });
    setTimeout(function () { fxTop.burst(x - 90, y - 110, { type: 'ring', scale: 0.8 }); }, 180);
    setTimeout(function () { fxTop.burst(x + 90, y - 120, { type: 'crackle', scale: 0.9 }); }, 320);
    if (big) {
      var W = window.innerWidth, H = window.innerHeight;
      fxTop.launch(W * 0.15, H * 0.25); fxTop.launch(W * 0.85, H * 0.22);
      setTimeout(function () { fxTop.launch(W * 0.5, H * 0.15, PALETTES[0]); }, 250);
    }
  }
  T.celebrate = celebrate;

  function initEmbers() {
    var wrap = document.querySelector('.embers');
    if (!wrap || reduceMotion) return;
    var n = isMobile ? 14 : 26, html = '';
    for (var i = 0; i < n; i++) {
      html += '<i style="--x:' + rand(0, 100).toFixed(1) + '%;--s:' + rand(2, 5).toFixed(1) + 'px;--d:' + rand(10, 22).toFixed(1) + 's;--delay:-' + rand(0, 20).toFixed(1) + 's;--dx:' + rand(-60, 60).toFixed(0) + 'px"></i>';
    }
    wrap.innerHTML = html;
  }

  /* ------------------------------------------------------------
     UI basics
  ------------------------------------------------------------ */
  function lockScroll(on) { document.documentElement.style.overflow = on ? 'hidden' : ''; }
  var overlay;
  function openPanel(panel) {
    overlay = overlay || $('[data-overlay]');
    panel.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var f = panel.querySelector('[data-autofocus]') || panel.querySelector('button, a, input');
    if (f) setTimeout(function () { f.focus({ preventScroll: true }); }, 250);
  }
  function closePanels() {
    $$('.menu-drawer.is-open, .cart-drawer.is-open').forEach(function (p) { p.classList.remove('is-open'); p.setAttribute('aria-hidden', 'true'); });
    var so = $('.search-overlay.is-open'); if (so) so.classList.remove('is-open');
    overlay = overlay || $('[data-overlay]');
    if (overlay) overlay.classList.remove('is-open');
    lockScroll(false);
  }
  T.closePanels = closePanels;

  function initHeader() {
    var header = $('.header');
    if (header) {
      var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 20); };
      onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
    }
    document.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-open-menu]'))) { e.preventDefault(); openPanel($('.menu-drawer')); }
      else if ((t = e.target.closest('[data-open-search]'))) {
        e.preventDefault();
        var so = $('.search-overlay'); so.classList.add('is-open'); lockScroll(true);
        setTimeout(function () { var i = so.querySelector('input'); if (i) i.focus(); }, 60);
      }
      else if ((t = e.target.closest('[data-open-cart]')) && $('#CartDrawer')) { e.preventDefault(); openCart(); }
      else if (e.target.closest('[data-close]') || e.target.matches('[data-overlay]') || e.target.matches('.search-overlay')) { closePanels(); }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });
  }

  function initPredictiveSearch() {
    var input = $('[data-predictive-input]'), out = $('[data-predictive-results]');
    if (!input || !out) return;
    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { out.innerHTML = ''; return; }
      timer = setTimeout(function () {
        fetch((T.routes.searchUrl || '/search') + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6')
          .then(function (r) { return r.json(); })
          .then(function (d) {
            var items = (d.resources && d.resources.results && d.resources.results.products) || [];
            if (!items.length) { out.innerHTML = '<p style="color:var(--muted)">No products found for “' + q.replace(/</g, '') + '”</p>'; return; }
            out.innerHTML = items.map(function (p) {
              var img = p.image ? '<img src="' + p.image + '&width=120" alt="" loading="lazy">' : '<span></span>';
              return '<a href="' + p.url + '">' + img + '<span>' + p.title + '</span><span class="price__now">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
            }).join('');
          }).catch(function () {});
      }, 220);
    });
  }

  function initReveal() {
    var els = $$('.reveal');
    if (!('IntersectionObserver' in window) || reduceMotion) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (e) { io.observe(e); });
  }

  function initCardFx() {
    if (!finePointer || reduceMotion) return;
    document.addEventListener('pointermove', function (e) {
      var card = e.target.closest && e.target.closest('.card');
      if (!card) return;
      var r = card.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      card.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
      card.style.setProperty('--my', (py * 100).toFixed(1) + '%');
      card.style.transform = 'perspective(900px) rotateY(' + ((px - 0.5) * 7).toFixed(2) + 'deg) rotateX(' + ((0.5 - py) * 7).toFixed(2) + 'deg) translateY(-6px)';
    }, { passive: true });
    document.addEventListener('pointerout', function (e) {
      var card = e.target.closest && e.target.closest('.card');
      if (card && !card.contains(e.relatedTarget)) card.style.transform = '';
    });
  }

  /* ------------------------------------------------------------
     Countdowns & delivery dates
  ------------------------------------------------------------ */
  function parseDate(str) {
    var p = (str || '').split('-');
    if (p.length !== 3) return null;
    return new Date(+p[0], +p[1] - 1, +p[2], 0, 0, 0);
  }
  function initCountdowns() {
    var cds = $$('[data-countdown]');
    var minis = $$('[data-days-to]');
    minis.forEach(function (m) {
      var d = parseDate(m.getAttribute('data-days-to'));
      if (!d) return;
      var days = Math.ceil((d - new Date()) / 86400000);
      if (days > 0) { var b = m.querySelector('b'); if (b) b.textContent = days + (days === 1 ? ' day' : ' days'); m.hidden = false; }
    });
    if (!cds.length) return;
    function tick() {
      cds.forEach(function (cd) {
        var d = parseDate(cd.getAttribute('data-countdown'));
        if (!d) return;
        var diff = d - new Date();
        if (diff <= 0) { cd.hidden = true; var done = cd.parentNode.querySelector('[data-countdown-done]'); if (done) done.hidden = false; return; }
        var vals = { d: Math.floor(diff / 86400000), h: Math.floor(diff / 3600000) % 24, m: Math.floor(diff / 60000) % 60, s: Math.floor(diff / 1000) % 60 };
        Object.keys(vals).forEach(function (k) {
          var el = cd.querySelector('[data-cd="' + k + '"]');
          if (!el) return;
          var v = String(vals[k]).padStart(2, '0');
          if (el.textContent !== v) { el.textContent = v; el.classList.remove('tick'); void el.offsetWidth; el.classList.add('tick'); }
        });
      });
    }
    tick(); setInterval(tick, 1000);
  }
  function initDeliveryDates() {
    $$('[data-delivery-est]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10) || 4, max = parseInt(el.getAttribute('data-max'), 10) || 8;
      var fmt = function (n) { var d = new Date(); d.setDate(d.getDate() + n); return d.toLocaleDateString('en-IN', { weekday: 'short', day: 'numeric', month: 'short' }); };
      var a = el.querySelector('[data-from]'), b = el.querySelector('[data-to]');
      if (a) a.textContent = fmt(min); if (b) b.textContent = fmt(max);
    });
  }

  /* ------------------------------------------------------------
     Toast
  ------------------------------------------------------------ */
  var toastTimer;
  function toast(msg) {
    var t = $('.toast');
    if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.innerHTML = msg;
    t.classList.add('is-show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-show'); }, 2800);
  }
  T.toast = toast;

  /* ------------------------------------------------------------
     Cart
  ------------------------------------------------------------ */
  function updateCounts(count) {
    $$('[data-cart-count]').forEach(function (b) {
      b.textContent = count; b.hidden = !count;
      b.classList.remove('bump'); void b.offsetWidth; b.classList.add('bump');
    });
  }
  function meterDone() { var m = $('#CartDrawer .meter'); return m ? m.classList.contains('is-done') : null; }

  function refreshCart() {
    var wasDone = meterDone();
    var jobs = [];
    var drawer = $('#CartDrawer');
    var oldMeter = $('#CartDrawer .meter');
    var oldP = oldMeter ? oldMeter.style.getPropertyValue('--p') : '0%';
    if (drawer) {
      jobs.push(fetch((T.routes.root || '/') + '?section_id=cart-drawer').then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('#CartDrawerInner');
        var cur = $('#CartDrawerInner');
        if (inner && cur) {
          var nm = inner.querySelector('.meter');
          var newP = nm ? nm.style.getPropertyValue('--p') : null;
          if (nm) nm.style.setProperty('--p', oldP || '0%');
          cur.replaceWith(inner);
          if (nm) requestAnimationFrame(function () { requestAnimationFrame(function () { nm.style.setProperty('--p', newP); }); });
        }
        var n = $('#CartDrawerInner'); if (n) updateCounts(parseInt(n.getAttribute('data-count'), 10) || 0);
      }));
    }
    var main = $('[data-main-cart]');
    if (main) {
      var id = main.getAttribute('data-section-id');
      jobs.push(fetch((T.routes.cart || '/cart') + '?section_id=' + id).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-main-cart]');
        if (fresh) main.replaceWith(fresh);
        var c = fresh && fresh.getAttribute('data-count'); if (c != null && !drawer) updateCounts(parseInt(c, 10) || 0);
        initDeliveryDates();
      }));
    }
    if (!jobs.length) jobs.push(fetch((T.routes.cart || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCounts(c.item_count); }));
    return Promise.all(jobs).then(function () {
      var nowDone = meterDone();
      if (wasDone === false && nowDone === true) {
        celebrate($('#CartDrawer .meter') || document.body, true);
        toast('🎉 FREE delivery unlocked!');
      }
      document.dispatchEvent(new CustomEvent('flexon:cart-updated'));
    });
  }
  T.refreshCart = refreshCart;

  function openCart() {
    var d = $('#CartDrawer');
    if (!d) { window.location.href = T.routes.cart || '/cart'; return; }
    var m = d.querySelector('.meter');
    if (m && !m.__animated) {
      var p = m.style.getPropertyValue('--p');
      m.style.setProperty('--p', '0%'); m.__animated = true;
      setTimeout(function () { m.style.setProperty('--p', p); }, 380);
    }
    openPanel(d);
  }
  T.openCart = openCart;

  function addToCart(formData, btn) {
    if (btn) btn.classList.add('is-loading');
    return fetch((T.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/json' }, body: formData })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (btn) btn.classList.remove('is-loading');
        if (!res.ok) { toast(res.data.description || res.data.message || 'Could not add this item'); return; }
        celebrate(btn, true);
        if (btn && btn.classList.contains('quick-add')) { btn.classList.add('is-added'); setTimeout(function () { btn.classList.remove('is-added'); }, 1600); }
        return refreshCart().then(function () {
          if (T.cartType === 'drawer' && $('#CartDrawer')) { setTimeout(openCart, 350); }
          else if (T.cartType === 'page') { toast('Added to cart ✨ <a href="' + (T.routes.cart || '/cart') + '" style="text-decoration:underline;color:var(--gold-2)">View cart</a>'); }
          else toast('Added to cart ✨');
        });
      })
      .catch(function () { if (btn) btn.classList.remove('is-loading'); toast('Network issue – please try again'); });
  }
  T.addToCart = addToCart;

  function changeLine(key, qty) {
    var host = document.querySelector('[data-line-key="' + key + '"]');
    if (host) host.style.opacity = '.5';
    return fetch((T.routes.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) { if (!res.ok) toast(res.data.description || 'Could not update the cart'); return refreshCart(); })
      .catch(function () { toast('Network issue – please try again'); if (host) host.style.opacity = ''; });
  }

  function initCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('[data-product-form]');
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('[data-atc]');
      if (e.submitter && e.submitter.hasAttribute('data-atc')) btn = e.submitter;
      if (form.__stickyBtn) { btn = form.__stickyBtn; form.__stickyBtn = null; }
      addToCart(new FormData(form), btn);
    });
    document.addEventListener('click', function (e) {
      var q = e.target.closest('[data-quick-add]');
      if (q) {
        e.preventDefault();
        var fd = new FormData(); fd.append('id', q.getAttribute('data-variant-id')); fd.append('quantity', '1');
        addToCart(fd, q); return;
      }
      var step = e.target.closest('[data-line-step]');
      if (step) {
        var key = step.getAttribute('data-key');
        var input = document.querySelector('[data-line-input][data-key="' + key + '"]');
        var cur = parseInt(input ? input.value : step.getAttribute('data-qty'), 10) || 0;
        changeLine(key, Math.max(0, cur + parseInt(step.getAttribute('data-line-step'), 10)));
        return;
      }
      var rm = e.target.closest('[data-line-remove]');
      if (rm) { e.preventDefault(); changeLine(rm.getAttribute('data-key'), 0); return; }
      var nt = e.target.closest('[data-note-toggle]');
      if (nt) { var box = $('[data-note-box]'); if (box) { box.hidden = !box.hidden; if (!box.hidden) box.querySelector('textarea').focus(); } }
    });
    document.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-line-input]');
      if (inp) changeLine(inp.getAttribute('data-key'), Math.max(0, parseInt(inp.value, 10) || 0));
      var note = e.target.closest('[data-cart-note]');
      if (note) fetch((T.routes.cart || '/cart') + '/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    });
  }

  /* ------------------------------------------------------------
     Product page
  ------------------------------------------------------------ */
  function initProduct(root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var form = root.querySelector('[data-product-form]');
    var idInput = form.querySelector('input[name="id"]');
    var atc = form.querySelector('[data-atc]');
    var atcLabel = atc.querySelector('.btn__label');
    var sticky = document.querySelector('[data-sticky-atc]');

    // gallery
    var track = root.querySelector('.gallery__track');
    var slides = track ? $$('.gallery__slide', track) : [];
    var dots = $$('.gallery__dots button', root), thumbs = $$('.gallery__thumbs button', root);
    function goTo(i, smooth) {
      if (!track || !slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    function setActive(i) {
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    if (track) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)); });
      }, { passive: true });
      dots.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      thumbs.forEach(function (d, i) { d.addEventListener('click', function () { goTo(i); }); });
      var prev = root.querySelector('.gallery__nav--prev'), next = root.querySelector('.gallery__nav--next');
      var cur = function () { return Math.round(track.scrollLeft / track.clientWidth); };
      if (prev) prev.addEventListener('click', function () { goTo((cur() - 1 + slides.length) % slides.length); });
      if (next) next.addEventListener('click', function () { goTo((cur() + 1) % slides.length); });
      if (finePointer) slides.forEach(function (s) {
        var img = s.querySelector('img'); if (!img) return;
        s.addEventListener('mousemove', function (e) {
          var r = s.getBoundingClientRect();
          img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
          img.style.transform = 'scale(1.9)';
        });
        s.addEventListener('mouseleave', function () { img.style.transform = ''; });
      });
    }

    // qty
    var qtyInput = form.querySelector('[data-qty-input]');
    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(b.getAttribute('data-qty-step'), 10));
        updateProductMeter();
      });
    });
    if (qtyInput) qtyInput.addEventListener('change', updateProductMeter);

    // variants
    function selectedOptions() {
      return product.options.map(function (name, i) {
        var checked = root.querySelector('input[data-option-index="' + i + '"]:checked');
        var sel = root.querySelector('select[data-option-index="' + i + '"]');
        return checked ? checked.value : sel ? sel.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.filter(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); })[0];
    }
    function currentVariant() { return product.variants.filter(function (v) { return String(v.id) === String(idInput.value); })[0] || product.variants[0]; }
    function renderPrice(v) {
      $$('[data-price-block]').forEach(function (pb) {
        var now = pb.querySelector('[data-price-now]'), was = pb.querySelector('[data-price-was]'), off = pb.querySelector('[data-price-off]');
        if (now) now.textContent = formatMoney(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (was) { was.textContent = onSale ? formatMoney(v.compare_at_price) : ''; was.hidden = !onSale; }
        if (off) { off.textContent = onSale ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% OFF' : ''; off.hidden = !onSale; }
      });
      var save = root.querySelector('[data-save]');
      if (save) {
        var onSale2 = v.compare_at_price && v.compare_at_price > v.price;
        save.hidden = !onSale2;
        if (onSale2) save.querySelector('b').textContent = formatMoney(v.compare_at_price - v.price);
      }
    }
    function renderAvailability() {
      product.options.forEach(function (name, i) {
        $$('input[data-option-index="' + i + '"]', root).forEach(function (inp) {
          var opts = selectedOptions(); opts[i] = inp.value;
          var v = findVariant(opts);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function onVariantChange() {
      var v = findVariant(selectedOptions());
      $$('[data-option-value]', root).forEach(function (el) { var i = +el.getAttribute('data-option-value'); el.textContent = selectedOptions()[i] || ''; });
      if (!v) {
        atc.disabled = true; atcLabel.textContent = 'Unavailable';
        if (sticky) { var sb = sticky.querySelector('.btn'); sb.disabled = true; }
        return;
      }
      idInput.value = v.id;
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? atc.getAttribute('data-label-add') : 'Sold out';
      if (sticky) { var sb2 = sticky.querySelector('.btn'); sb2.disabled = !v.available; sb2.querySelector('.btn__label').textContent = v.available ? 'Add to Cart' : 'Sold out'; }
      renderPrice(v);
      renderAvailability();
      if (v.featured_media) {
        var idx = slides.map(function (s) { return s.getAttribute('data-media-id'); }).indexOf(String(v.featured_media.id));
        if (idx > -1) goTo(idx);
      }
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      updateProductMeter();
    }
    root.addEventListener('change', function (e) { if (e.target.hasAttribute('data-option-index')) onVariantChange(); });
    renderAvailability();

    // product-level free delivery nudge
    var pm = root.querySelector('[data-product-meter]');
    var cartTotal = 0;
    function updateProductMeter() {
      if (!pm) return;
      var threshold = T.freeShippingCents || 0;
      if (!threshold) { pm.hidden = true; return; }
      var v = currentVariant();
      var q = parseInt(qtyInput && qtyInput.value, 10) || 1;
      var after = cartTotal + v.price * q;
      var remaining = threshold - after;
      var txt = pm.querySelector('[data-pm-text]');
      var fill = pm.querySelector('.meter');
      var pct = Math.min(100, Math.round(after * 100 / threshold));
      if (fill) { fill.style.setProperty('--p', pct + '%'); fill.classList.toggle('is-done', remaining <= 0); }
      if (txt) txt.innerHTML = remaining > 0
        ? 'Add this + <strong>' + formatMoney(remaining) + '</strong> more for <strong>FREE delivery</strong>'
        : '<strong>This order gets FREE delivery!</strong> 🎉';
    }
    function loadCartTotal() {
      fetch((T.routes.cart || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) { cartTotal = c.total_price || 0; updateProductMeter(); }).catch(updateProductMeter);
    }
    loadCartTotal();
    document.addEventListener('flexon:cart-updated', loadCartTotal);

    // sticky ATC
    if (sticky && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        var e = en[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        document.body.classList.toggle('has-sticky-atc', show);
      });
      io.observe(atc);
      sticky.querySelector('.btn').addEventListener('click', function (ev) {
        form.__stickyBtn = ev.currentTarget;
        if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
      });
    }

    // share
    var share = root.querySelector('[data-share]');
    if (share) share.addEventListener('click', function () {
      var data = { title: product.title, url: window.location.href.split('?')[0] };
      if (navigator.share) navigator.share(data).catch(function () {});
      else if (navigator.clipboard) navigator.clipboard.writeText(data.url).then(function () { toast('Link copied ✨'); });
    });
  }

  /* ------------------------------------------------------------
     Boot
  ------------------------------------------------------------ */
  function boot() {
    initFx();
    initEmbers();
    initHeader();
    initPredictiveSearch();
    initReveal();
    initCardFx();
    initCountdowns();
    initDeliveryDates();
    initCart();
    $$('[data-product-root]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.FlexOn = T;
})();
